import { render, staticRenderFns } from "./comp_Hook-OrderSummaryItem-MakingTimeMsg.vue?vue&type=template&id=c848b2a4"
import script from "./comp_Hook-OrderSummaryItem-MakingTimeMsg.vue?vue&type=script&lang=js"
export * from "./comp_Hook-OrderSummaryItem-MakingTimeMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports